import { type FC } from "react";

import { type DraftingFieldFragment } from "@app_schema";

import { CitationChip } from "@styled/citation_chip";
import { FieldValueEdit } from "@styled/field_value_edit";
import { SetupReviewField } from "@styled/setup_review";

import { useOpenPage } from "./use_open_page";

// A fill-in field: his label, what it reads on this case and the record page
// it's from, or why there's none; a click on it corrects it for this case.
export const DraftingFieldRow: FC<{
  field: DraftingFieldFragment;
  onSave(kind: string, value: string): void;
}> = ({ field, onSave }) => {
  const openPage = useOpenPage();
  const { documentId, page, value } = field;

  return (
    <SetupReviewField label={field.label} line={value ? field.line : null}>
      <FieldValueEdit
        label={field.label}
        value={value ?? null}
        empty={field.line ?? null}
        waiting={field.waiting}
        onSave={(next) => onSave(field.kind, next)}
      />
      {value && openPage && documentId && page != null && (
        <CitationChip
          pages={[page]}
          onPress={() => openPage({ documentId, page })}
        />
      )}
    </SetupReviewField>
  );
};
